module.exports = __webpack_public_path__ + "img/3.61a50fb1.png";